/* src/app/forms/generic-log/generic-log.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 20px;
}
.log-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  gap: 10px;
}
.wrapper-table {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
}
.search-box {
  padding: 8px;
}
.search-box input {
  width: 188px;
  margin-bottom: 8px;
  display: block;
}
.search-box button {
  width: 90px;
}
.search-button {
  margin-right: 8px;
}
.result {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.json-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}
.log-float-button {
  position: absolute;
  bottom: 100px;
  right: 30px;
}
.quick-filter {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
}
.filter-divider {
  margin: 0;
}
.full-width {
  width: 100%;
  max-width: 50%;
}
/*# sourceMappingURL=generic-log.component.css.map */
